import React from 'react';

function ViewModeSelector({ viewMode, setViewMode, onExport, resultCount }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-4">
      <div className="bg-slate-50 rounded-lg border border-slate-200 px-4 py-3 flex items-center justify-between gap-4">
        {/* View toggles */}
        <div className="flex gap-2">
          <button
            className={`tab-button ${viewMode === 'cards' ? 'active' : ''}`}
            onClick={() => setViewMode('cards')}
          >
            <i className="fas fa-th-large mr-1.5"></i>Cards
          </button>
          <button
            className={`tab-button ${viewMode === 'table' ? 'active' : ''}`}
            onClick={() => setViewMode('table')}
          >
            <i className="fas fa-table mr-1.5"></i>Table
          </button>
          <button
            className={`tab-button ${viewMode === 'timeline' ? 'active' : ''}`}
            onClick={() => setViewMode('timeline')}
          >
            <i className="fas fa-stream mr-1.5"></i>Timeline
          </button>
        </div>

        {/* Right side: result count + export */}
        <div className="flex items-center gap-3">
          {resultCount !== undefined && (
            <span className="text-sm text-gray-400 hidden sm:inline">
              <strong className="text-gray-600">{resultCount}</strong> {resultCount === 1 ? 'law' : 'laws'}
            </span>
          )}
          <button
            onClick={onExport}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-gray-600 hover:text-gray-900 border border-gray-200 hover:border-gray-400 rounded-lg bg-slate-100 hover:bg-slate-200 transition-colors"
            title="Export current view to CSV"
          >
            <i className="fas fa-download text-purple-500"></i>
            <span className="hidden sm:inline">Export CSV</span>
          </button>
          <button
            onClick={() => {
              navigator.clipboard?.writeText(window.location.href);
              // brief visual feedback handled by title tooltip
            }}
            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-gray-600 hover:text-gray-900 border border-gray-200 hover:border-gray-400 rounded-lg bg-slate-100 hover:bg-slate-200 transition-colors"
            title="Copy shareable link to clipboard"
          >
            <i className="fas fa-link text-purple-500"></i>
            <span className="hidden sm:inline">Copy Link</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewModeSelector;
